import { Editor, Plugin } from 'grapesjs';

const plugin: Plugin<{}> = (editor: Editor) => {
  editor.Commands.add('open-style-manager', {
    run: (editor) => {
      const selected = editor.getSelected();

      if (!selected) {
        return;
      }

      selected.getSelectors().models.forEach((selector) => {
        const name = selector.get('name');

        editor.StyleManager.select(name);
      });
    },
  });

  const styleManager = editor.StyleManager;

  editor.on('load', () => {
    styleManager.addProperty('flex', {
      name: 'Gap',
      property: 'gap',
      units: ['px', '%'],
      defaults: '0',
      type: 'number',
    });

    styleManager.addProperty('dimension', {
      name: 'Min Width',
      property: 'min-width',
      units: ['px', '%'],
      defaults: 'auto',
      type: 'number',
    });

    styleManager.addProperty('dimension', {
      name: 'Max Height',
      property: 'max-height',
      units: ['px', '%'],
      defaults: 'auto',
      type: 'number',
    });

    styleManager.addProperty('typography', {
      name: 'White Space',
      property: 'white-space',
      type: 'select',
      defaults: 'normal',
      list: [
        { id: 'normal', value: 'normal', name: 'Normal' },
        { id: 'nowrap', value: 'nowrap', name: 'No Wrap' },
        { id: 'pre', value: 'pre', name: 'Pre' },
        { id: 'pre-wrap', value: 'pre-wrap', name: 'Pre Wrap' },
        { id: 'pre-line', value: 'pre-line', name: 'Pre Line' },
      ],
    });

    styleManager.addProperty('typography', {
      name: 'Overflow',
      property: 'overflow',
      type: 'select',
      defaults: 'visible',
      list: [
        { id: 'visible', value: 'visible', name: 'Visible' },
        { id: 'hidden', value: 'hidden', name: 'Hidden' },
      ],
    });

    styleManager.addProperty('typography', {
      name: 'Text Overflow',
      property: 'text-overflow',
      type: 'select',
      defaults: 'clip',
      list: [
        { id: 'clip', value: 'clip', name: 'Clip' },
        { id: 'ellipsis', value: 'ellipsis', name: 'Ellipsis' },
      ],
    });

    styleManager.addProperty('typography', {
      name: 'Word Break',
      property: 'word-break',
      type: 'select',
      defaults: 'normal',
      list: [
        { id: 'normal', value: 'normal', name: 'Normal' },
        { id: 'break-all', value: 'break-all', name: 'Break All' },
        { id: 'keep-all', value: 'keep-all', name: 'Keep All' },
        { id: 'break-word', value: 'break-word', name: 'Break Word' },
      ],
    });

    styleManager.addProperty('typography', {
      name: 'Overflow Wrap',
      property: 'overflow-wrap',
      type: 'select',
      defaults: 'normal',
      list: [
        { id: 'normal', value: 'normal', name: 'Normal' },
        { id: 'break-word', value: 'break-word', name: 'Break Word' },
        { id: 'anywhere', value: 'anywhere', name: 'Anywhere' },
      ],
    });
  });

  styleManager.addSector('border', {
    name: 'Border',
    open: false,
    buildProps: [
      'border-style',
      'border-top-color',
      'border-top-width',
      'border-right-color',
      'border-right-width',
      'border-bottom-color',
      'border-bottom-width',
      'border-left-color',
      'border-left-width',
    ],
    properties: [
      {
        property: 'border-style',
        type: 'select',
        defaults: 'solid',
        options: [
          { id: 'none', value: 'none', name: 'None' },
          { id: 'solid', value: 'solid', name: 'Solid' },
          { id: 'dashed', value: 'dashed', name: 'Dashed' },
          { id: 'dotted', value: 'dotted', name: 'Dotted' },
        ],
      },
      { property: 'border-top-color', name: 'Border Top Color', type: 'color' },
      { property: 'border-top-width', name: 'Border Top Width', type: 'slider', units: ['px'], min: 0, max: 20 },
      { property: 'border-right-color', name: 'Border Right Color', type: 'color' },
      { property: 'border-right-width', name: 'Border Right Width', type: 'slider', units: ['px'], min: 0, max: 20 },
      { property: 'border-bottom-color', name: 'Border Bottom Color', type: 'color' },
      { property: 'border-bottom-width', name: 'Border Bottom Width', type: 'slider', units: ['px'], min: 0, max: 20 },
      { property: 'border-left-color', name: 'Border Left Color', type: 'color' },
      { property: 'border-left-width', name: 'Border Left Width', type: 'slider', units: ['px'], min: 0, max: 20 },
    ],
  });
};

export default plugin;
